import { Component } from '@angular/core';

@Component({
  templateUrl: './notallowed-page.component.html',
    styleUrls: ['./notallowed-page.component.scss']
})
export class NotallowedComponent {}
